import { Component, OnInit } from '@angular/core';
import { CompetitionInitService } from '../../../services/competition-init.service';

@Component({
  selector: 'app-bootstrap-competitions-info',
  templateUrl: './bootstrap-competitions-info.component.html',
  styleUrls: ['./bootstrap-competitions-info.component.scss']
})
export class BootstrapCompetitionsInfoComponent {

  constructor(public competition_service:CompetitionInitService) { }
}
